// src/pages/doctorPages/DrProfile/DrProfile.jsx
"use client";

import React, { useEffect, useState } from "react";
import "./DoctorProfile.css";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import DoctorHeaderCard from "../../componants/DoctorProfilePage/DoctorHeaderCard/DoctorHeaderCard";
import DoctorTabs from "../../componants/DoctorProfilePage/DoctorTabs/DoctorTabs";
import DoctorInfoPanel from "../../componants/DoctorProfilePage/DoctorInfoPanel/DoctorInfoPanel";
import AppointmentBookingCard from "../../componants/DoctorProfilePage/AppointmentBookingCard/AppointmentBookingCard";

import { fetchDoctorById, getCurrentDoctor } from "../../../authDoctor/redux/thunks/doctorsThunks";
import { getFollowedDoctorsThunk } from "../../../ProfileDoctor/redux/thunks/followsThunks";
import AppLayoutDoctor from "../../../navigation/Layout/LayoutDoctor";

import useLoadFollows from "../../hooks/useLoadFollows";
import Cookies from "js-cookie";
export default function DrProfile() {
  const dispatch = useDispatch();
  const { doctorId } = useParams();
  useLoadFollows();

  const [activeTab, setActiveTab] = useState("info");

  // 🔍 DEBUG: Full Redux state
  const fullReduxState = useSelector((s) => s);

  // ✅ Récupère le doctor connecté
  const currentDoctor = useSelector((s) => s.doctors?.currentDoctor || s.doctor?.currentDoctor);
  const currentUserId = currentDoctor?.id;


  const doctorsSlice = useSelector((state) => state.doctors || state.doctor);
  const doctor = doctorsSlice?.selectedDoctor;
  const loading = doctorsSlice?.loadingSelectedDoctor;
  const error = doctorsSlice?.errorSelectedDoctor;


  // ✅ Charge getCurrentDoctor UNE SEULE FOIS au montage
  useEffect(() => {
    
    if (!currentDoctor) {
      const accessToken = Cookies.get("accessToken");
      const doctorSession = Cookies.get("doctorSession");
      
      
      if (accessToken || doctorSession) {
        
        dispatch(getCurrentDoctor())
          .unwrap()
          .then((result) => {
          })
          .catch((err) => {
            console.error("❌ getCurrentDoctor FAILED:", err);
          });
      } else {
        console.warn("⚠️ No token found - cannot load current doctor");
      }
    } else {
    }
  }, []); // ✅ Empty deps = run once

  // Charge le doctor à afficher
  useEffect(() => {
    if (doctorId) {
      dispatch(fetchDoctorById({ id: doctorId }));
    }
  }, [dispatch, doctorId]);

  // Charge les follows
  useEffect(() => {
    if (currentUserId) {
      dispatch(getFollowedDoctorsThunk({ 
        followerId: String(currentUserId)
      }));
    } else {
      console.warn("⚠️ [DrProfile] Cannot load follows - no currentUserId");
    }
  }, [dispatch, currentUserId]);

  if (loading) {
    return (
      <AppLayoutDoctor>
        <div className="dp-page">Loading doctor profile...</div>
      </AppLayoutDoctor>
    );
  }

  if (error) {
    return (
      <AppLayoutDoctor>
        <div className="dp-page">
          <p style={{ color: "crimson" }}>{String(error)}</p>
        </div>
      </AppLayoutDoctor>
    );
  }

  if (!doctor) {
    return (
      <AppLayoutDoctor>
        <div className="dp-page">
          <p>Doctor not found.</p>
        </div>
      </AppLayoutDoctor>
    );
  }

  return (
    <AppLayoutDoctor>
      <div className="dp-page">
        <DoctorHeaderCard
          doctor={doctor}
          doctorIdOverride={doctorId}
          showEdit={false}
          isDoctorSession
        />
        <DoctorTabs active={activeTab} onChange={setActiveTab} />

        <div className="dp-grid">
          <div className="dp-left">
            <DoctorInfoPanel doctor={doctor} activeTab={activeTab} />
          </div>

          <div className="dp-right">
            <AppointmentBookingCard
              doctor={doctor}
              onBooked={(payload) => undefined}
            />
          </div>
        </div>
      </div>
    </AppLayoutDoctor>
  );
}